export enum ALERT_VARIANTS {
  ERROR = 'ERROR',
  WARNING = 'WARNING',
  INFO = 'INFO',
  EXCLAMATION = 'EXCLAMATION',
}
